import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SaveScriptService {
  scriptURL = '/entity/v1/application';
  constructor(private http: HttpClient) {}

  // eslint-disable-next-line
  saveScript(id: number, scriptValue: string, scriptName: string): Observable<any> {
    const blob = new Blob([scriptValue], { type: 'text/plain' });
    const file: File = new File([blob], scriptName, { type: 'text/plain' });
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.http.post(`${this.scriptURL}/${id}/script`, formData);
  }
}
